module.exports = __webpack_public_path__ + "img/logo.e6081a3d.svg";